import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./audit.css";
import "./app.css";
import AppRoot from "./AppRoot";

// One-time clear of stale Express tool cards (generated before the per-card trash button),
// so newly generated cards in the Express Schema / Internal Links / Meta Data tabs include
// the trashcan. Runs once per browser; the pasted URLs are kept so a single Continue
// regenerates them. Runs before React mounts (the Express components read these on init).
try {
  if (!localStorage.getItem("lsg_express_trash_migration")) {
    ["lsg_bps_cards", "lsg_bil_cards", "lsg_bmd_cards"].forEach(k => localStorage.removeItem(k));
    localStorage.setItem("lsg_express_trash_migration", "1");
  }
} catch { /* ignore */ }

// Force scrollbar sizes — injected last so it wins over all CSS
const scrollbarStyle = document.createElement("style");
scrollbarStyle.textContent = `
  .topnav { overflow-x: auto !important; }
  .topnav::-webkit-scrollbar { height: 20px !important; background: #1a2535 !important; }
  .topnav::-webkit-scrollbar-track { background: #1a2535 !important; border-radius: 0 !important; }
  .topnav::-webkit-scrollbar-thumb { background: #facc15 !important; border-radius: 4px !important; min-width: 40px !important; }
  .topnav::-webkit-scrollbar-thumb:hover { background: #fde047 !important; }
  ::-webkit-scrollbar { height: 14px !important; width: 14px !important; }
  ::-webkit-scrollbar-track { background: #e2e8f0 !important; }
  ::-webkit-scrollbar-thumb { background: #fdba74 !important; border-radius: 4px !important; }
  ::-webkit-scrollbar-thumb:hover { background: #fb923c !important; }
  ::-webkit-scrollbar-corner { background: #e2e8f0 !important; }
`;
document.head.appendChild(scrollbarStyle);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>
);
